import type { ReactNode } from 'react';

import Icon from '../Icon';

import './EmptyState.scss';

/** Пропсы заглушки «пусто» EmptyState. */
export interface EmptyStateProps {
  /** Имя иконки (Icon) над текстом; не задано — только текст */
  icon?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Заглушка «здесь пока пусто»: серый прямоугольник с иконкой и текстом
 * (цвета текста задаёт потребитель через className, напр. text-muted).
 * Выделено из мастера ШМ (tfw-cart-empty) в коллекцию ui.
 */
const EmptyState = ({ icon, className, children }: EmptyStateProps) => (
  <div className={ `empty-state${ className ? ` ${ className }` : '' }` }>
    { icon && <div className='empty-state-icon'><Icon name={ icon } /></div> }
    { children }
  </div>
);

export default EmptyState;
